// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.broker_main_div {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    width: 100%;
}

.broker_main_div > hr {
    display: none;
}

.broker_div {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.broker_name_title {
    margin: 0 0 4px 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    letter-spacing: -0.01em;
}

.broker_alert_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 14px 18px;
    gap: 14px;
    border-radius: var(--radius-md);
    width: 100%;
    transition: all var(--transition-fast);
}

.sufficient_amount {
    background-color: var(--success-light);
    border: 1px solid rgba(34, 197, 94, 0.2);
    border-left: 3px solid var(--success);
}

.unsufficient_amount {
    background-color: var(--danger-light);
    border: 1px solid rgba(239, 68, 68, 0.2);
    border-left: 3px solid var(--danger);
}

.broker_alert_box_text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.5;
}

.sufficient_amount .broker_alert_box_text {
    color: #15803D;
}

.unsufficient_amount .broker_alert_box_text {
    color: #B91C1C;
}

[data-theme="dark"] .sufficient_amount .broker_alert_box_text {
    color: var(--success);
}

[data-theme="dark"] .unsufficient_amount .broker_alert_box_text {
    color: var(--danger);
}

.broker_alert_icon {
    width: 36px;
    height: 36px;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 16px;
    font-weight: 700;
}

.sufficient_amount .broker_alert_icon {
    background-color: rgba(34, 197, 94, 0.15);
    color: var(--success);
}

.unsufficient_amount .broker_alert_icon {
    background-color: rgba(239, 68, 68, 0.15);
    color: var(--danger);
}

@media (max-width: 768px) {
    .broker_main_div {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DataComponents/BrokerAlert/brokerAlert.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,+BAA+B;IAC/B,WAAW;IACX,sCAAsC;AAC1C;;AAEA;IACI,sCAAsC;IACtC,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".broker_main_div {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    width: 100%;\n}\n\n.broker_main_div > hr {\n    display: none;\n}\n\n.broker_div {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.broker_name_title {\n    margin: 0 0 4px 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n    letter-spacing: -0.01em;\n}\n\n.broker_alert_box {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 14px 18px;\n    gap: 14px;\n    border-radius: var(--radius-md);\n    width: 100%;\n    transition: all var(--transition-fast);\n}\n\n.sufficient_amount {\n    background-color: var(--success-light);\n    border: 1px solid rgba(34, 197, 94, 0.2);\n    border-left: 3px solid var(--success);\n}\n\n.unsufficient_amount {\n    background-color: var(--danger-light);\n    border: 1px solid rgba(239, 68, 68, 0.2);\n    border-left: 3px solid var(--danger);\n}\n\n.broker_alert_box_text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 1.5;\n}\n\n.sufficient_amount .broker_alert_box_text {\n    color: #15803D;\n}\n\n.unsufficient_amount .broker_alert_box_text {\n    color: #B91C1C;\n}\n\n[data-theme=\"dark\"] .sufficient_amount .broker_alert_box_text {\n    color: var(--success);\n}\n\n[data-theme=\"dark\"] .unsufficient_amount .broker_alert_box_text {\n    color: var(--danger);\n}\n\n.broker_alert_icon {\n    width: 36px;\n    height: 36px;\n    border-radius: var(--radius-sm);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.sufficient_amount .broker_alert_icon {\n    background-color: rgba(34, 197, 94, 0.15);\n    color: var(--success);\n}\n\n.unsufficient_amount .broker_alert_icon {\n    background-color: rgba(239, 68, 68, 0.15);\n    color: var(--danger);\n}\n\n@media (max-width: 768px) {\n    .broker_main_div {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
